// eslint-disable-next-line import/prefer-default-export
export const SET_INITIAL_MAX_PRICE = 'SET_INITIAL_MAX_PRICE';
export const SET_INITIAL_MIN_PRICE = 'SET_INITIAL_MIN_PRICE';
